var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { Time as $35ea8db9cb2ccb90$export$680ea196effce5f, CalendarDate as $35ea8db9cb2ccb90$export$99faa760c7908e4f, CalendarDateTime as $35ea8db9cb2ccb90$export$ca871e8dbb80966f } from "../../../node_modules/.pnpm/@internationalized_date@3.8.1/node_modules/@internationalized/date/dist/CalendarDate.js";
function DateToCalendarDateTime(d) {
  const date = d || /* @__PURE__ */ new Date();
  return new $35ea8db9cb2ccb90$export$ca871e8dbb80966f(
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    date.getMilliseconds()
  );
}
__name(DateToCalendarDateTime, "DateToCalendarDateTime");
function CalendarDateTimeToDate(c, t) {
  return t ? new Date(c.year, c.month - 1, c.day, t.hour, t.minute, t.second) : c instanceof $35ea8db9cb2ccb90$export$99faa760c7908e4f ? new Date(c.year, c.month - 1, c.day) : new Date(c.year, c.month - 1, c.day, c.hour, c.minute, c.second, c.millisecond);
}
__name(CalendarDateTimeToDate, "CalendarDateTimeToDate");
function DateToTime(d) {
  const date = d || /* @__PURE__ */ new Date();
  return new $35ea8db9cb2ccb90$export$680ea196effce5f(date.getHours(), date.getMinutes(), date.getSeconds());
}
__name(DateToTime, "DateToTime");
function TimeToDate(d, t) {
  const date = d || /* @__PURE__ */ new Date();
  return date.setHours(t.hour), date.setMinutes(t.minute), date.setSeconds(t.second), new Date(date);
}
__name(TimeToDate, "TimeToDate");
export {
  CalendarDateTimeToDate,
  DateToCalendarDateTime,
  DateToTime,
  TimeToDate
};
//# sourceMappingURL=utils.js.map
